module.exports = __webpack_public_path__ + "static/media/behind-the-waves.4c528538.jpg";